import { useState, memo, useEffect } from 'react'
import Logo from '@/components/layout/Header/Logo'
import HeaderNav from '@/components/layout/Header/HeaderNav'
import HeaderActions from '@/components/layout/Header/HeaderActions'

const Header = memo(() => {
  // Centralized state management
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  // Unified handlers
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)
  const closeMenu = () => setIsMenuOpen(false)

  // Body scroll lock when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isMenuOpen])

  return (
    <>
      {/* Desktop Header */}
      <header
        className="hidden xl:block sticky top-0 z-50 w-full border-b border-brand-purple/20 bg-gradient-to-r from-brand-purple/10 via-brand-pink/10 to-brand-blue/10 backdrop-blur-md supports-[backdrop-filter]:bg-background/80 shadow-lg shadow-brand-purple/10"
        role="banner"
      >
        <div className="container px-6 flex h-20 items-center justify-between">
          <Logo />
          <div
            className="flex items-center space-x-10"
            role="navigation"
            aria-label="Hauptnavigation"
          >
            <HeaderNav isMenuOpen={false} />
            <HeaderActions onCloseMenu={closeMenu} />
          </div>
        </div>
      </header>

      {/* Mobile Header Container */}
      <div className="xl:hidden fixed top-0 left-0 right-0 z-50">
        {/* Mobile Header */}
        <header
          className="w-full border-b border-brand-purple/20 bg-gradient-to-r from-brand-purple/10 via-brand-pink/10 to-brand-blue/10 backdrop-blur-md supports-[backdrop-filter]:bg-background/80 shadow-lg shadow-brand-purple/10"
          role="banner"
        >
          <div className="container px-4 flex h-16 items-center justify-between space-x-4">
            <Logo />
            <HeaderActions
              isMenuOpen={isMenuOpen}
              onToggleMenu={toggleMenu}
              onCloseMenu={closeMenu}
            />
          </div>
        </header>

        {/* Mobile Menu */}
        <HeaderNav isMenuOpen={isMenuOpen} onToggleMenu={toggleMenu} />
      </div>
    </>
  )
})

export default Header
